@if (form) {
  <div class="bg-beige py-8">
    <section class="layout">
      <div
        class="bg-white rounded-xl lg:flex justify-between py-2">

        <form [formGroup]="form"
              class="w-full md:grid grid-cols-2 gap-x-20 p-8 md:p-16 xl:p-24">
          <div class="col-span-2 mb-4">
            @if (centerService.center(); as siteCenter) {
              <div class="text-gray-500 text-xl font-semibold">
                <p>
                  {{ 'citySelectionTitle' | translate }}
                  <span class="text-bleuCaliceo-300">{{ siteCenter.name }}</span>
                </p>
                <p class="text-gray-500 text-sm mt-1">
                  {{ 'citySelectionDescription' | translate }}
                </p>
                <p [innerHTML]="'otherCenterLink' | translate | byPass" class="text-gray-400 text-xs mt-2"></p>
              </div>
            } @else {
              <div appAutoClose="always" class="relative w-full">
                <button aria-labelledby="centerChoice"
                        class="border border-gray-200 hover:bg-gray-50 py-5 px-4 pr-10 md:px-7 disabled:bg-gray-200 duration-200 cursor-pointer relative w-full rounded-md text-left text-gray-900 focus:outline-none"
                        type="button">
                  <span class="flex items-center">
                    <div class="w-12">
                      <img alt="{{'caliceoLocation' | translate}}" class="h-9 w-9 flex-shrink-0 m-auto" height="60"
                           ngSrc="assets/icons/gray/location.svg" width="60">
                    </div>
                    <span class="truncate text-gray-500 font-semibold text-lg ml-4 md:ml-6">
                      <p class="font-semibold truncate text-base" id="centerChoice">
                        {{ 'centerSelectionQuestion' | translate }}
                      </p>
                      {{ centerService.withErpId(form.get('centerErpId')?.value ?? -1)?.name }}
                    </span>
                  </span>
                  <span class="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-6">
                    <img alt="" class="h-4 w-4" height="60" ngSrc="assets/icons/gray/down.svg" width="60">
                  </span>
                </button>
                <ul
                  class="hidden absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                  role="listbox" tabindex="-1">
                  @for (center of activeCenters(); track center.id) {
                    <li (click)="form.get('centerErpId')?.setValue(center.erpId)"
                        (keyup.enter)="emulateClick($event)"
                        [attr.aria-selected]="form.get('centerErpId')?.value === center.erpId"
                        class="text-gray-900 hover:bg-gray-100 relative select-none py-4 px-3 md:px-5 cursor-pointer"
                        role="option"
                        tabindex="0">
                      <div class="flex items-center">
                        <span
                          [ngClass]="form.get('centerErpId')?.value === center.erpId ? 'font-semibold' : 'font-normal'"
                          class="text-lg text-gray-500 ml-3 block truncate">
                          {{ center.name }} @if (center.city; as city) {
                          - {{ city }}
                        }
                        </span>
                      </div>
                    </li>
                  }
                </ul>
                <p class="text-gray-500 text-sm mt-2">{{ 'centerSelectionDescription' | translate }}</p>
              </div>
            }
          </div>
          <div>
            <div class="flex md:flex-row flex-col gap-4 mb-4">
              <div class="w-full md:w-1/2 mb-6 md:mb-0">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="firstName">
                  {{ 'firstName' | translate }} <span class="text-red-600">*</span>
                </label>
                <input
                  class="appearance-none block w-full border-gray-200 text-gray-700 border rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white disabled:bg-gray-100"
                  formControlName="firstName"
                  id="firstName"
                  type="text">
              </div>
              <div class="w-full md:w-1/2">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="lastName">
                  {{ 'lastName' | translate }} <span class="text-red-600">*</span>
                </label>
                <input
                  class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                  formControlName="lastName"
                  id="lastName"
                  type="text">
              </div>
            </div>
            <div class="flex flex-wrap mb-4">
              <div class="w-full">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="address">
                  {{ 'address' | translate }} <span class="text-red-600">*</span>
                </label>
                <input
                  class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                  formControlName="address"
                  id="address"
                  type="text">
              </div>
            </div>
            <div class="flex flex-wrap mb-4">
              <div class="w-full">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="additionalAddress">
                  {{ 'additionalAddress' | translate }}
                </label>
                <input
                  class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                  formControlName="additionalAddress"
                  id="additionalAddress"
                  type="text">
              </div>
            </div>

            <div class="flex md:flex-row flex-col gap-4 mb-4">
              <div class="w-full md:w-1/2 mb-6 md:mb-0">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="zip">
                  {{ 'zip' | translate }} <span class="text-red-600">*</span>
                </label>
                <input
                  class="appearance-none block w-full border-gray-200 text-gray-700 border rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white disabled:bg-gray-100"
                  formControlName="zip"
                  id="zip"
                  type="text">
                @if (displayCities()) {
                  <div class="absolute z-10 flex w-screen max-w-min">
                    <div
                      class="w-56 shrink rounded-xl bg-white p-4 text-sm font-semibold leading-6 text-gray-900 shadow-lg ring-1 ring-gray-900/5">
                      @for (city of cities(); track city) {
                        <button (click)="setCity(city)" class="block p-2 hover:text-bleuCaliceo-400">{{ city }}</button>
                      }
                    </div>
                  </div>
                }
              </div>
              <div class="w-full md:w-1/2">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="city">
                  {{ 'city' | translate }} <span class="text-red-600">*</span>
                </label>
                <input
                  (input)="setCity($any($event.target).value)"
                  [readOnly]="hasCityList()"
                  [value]="form.get('city')?.value"
                  class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 read-only:bg-gray-100"
                  id="city"
                  type="text">
              </div>
            </div>
            <div class="flex flex-wrap mb-4">
              <label class="text-gray-500 text-md font-semibold pb-2 block" for="country">
                {{ 'country' | translate }} <span class="text-red-600">*</span>
              </label>
              <select autocomplete="country"
                      class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                      formControlName="country"
                      id="country"
                      name="country">
                @for (country of sortedCountries(); track country.libelle; ) {
                  <option [value]="country.libelle">{{ country.libelle }}</option>
                }
              </select>
            </div>
            <div class="flex flex-wrap mb-4">
              <div class="w-full">
                <app-tel-input [allowedCountries]="['BE', 'DE']" formControlName="phone"/>
                @if (form.get('phone')?.errors?.['pattern'] || form.get('phone')?.errors?.['mustBeE164']) {
                  <p class="peer-invalid:visible text-red-600 text-xs mt-2">
                    {{ 'phoneRules' | translate }}
                  </p>
                }
              </div>
            </div>
          </div>
          <div>
            <div class="flex flex-wrap mb-4">
              <div class="w-full">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="birthDate">
                  {{ 'yourBirthday' | translate }} <span class="text-red-600">*</span>
                </label>
                <div class="flex gap-4" id="birthDate">
                  <select autocomplete="bday-day"
                          class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                          formControlName="birthDay"
                          id="birthDay"
                          name="birthDay">
                    @for (day of days; track day) {
                      <option
                        [disabled]="!isValidDate(form.get('birthYear')!.value, form.get('birthMonth')!.value, day)"
                        [value]="day">{{ day }}
                      </option>
                    }
                  </select>
                  <select autocomplete="bday-month"
                          class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                          formControlName="birthMonth"
                          id="birthMonth"
                          name="birthMonth">
                    @for (month of months; track month) {
                      <option
                        [disabled]="!isValidDate(form.get('birthYear')!.value, month, form.get('birthDay')!.value)"
                        [value]="month">{{ month }}
                      </option>
                    }
                  </select>
                  <select autocomplete="bday-year"
                          class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                          formControlName="birthYear"
                          id="birthYear"
                          name="birthYear">
                    @for (year of years; track year) {
                      <option
                        [disabled]="!isValidDate(year, form.get('birthMonth')!.value, form.get('birthDay')!.value)"
                        [value]="year">{{ year }}
                      </option>
                    }
                  </select>
                </div>
              </div>
            </div>
            <div class="flex flex-wrap mb-4">
              <div class="w-full">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="email">
                  {{ 'yourEmail' | translate }} <span class="text-red-600">*</span>
                </label>
                <input
                  class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                  formControlName="email"
                  id="email"
                  type="email">
              </div>
            </div>
            <div class="flex flex-wrap mb-4">
              <div class="w-full">
                <label class="text-gray-500 text-md font-semibold pb-2 block" for="password">
                  {{ 'yourPassword' | translate }} <span class="text-red-600">*</span>
                </label>
                <div class="relative mb-3 w-full flex">
                  <input
                    [type]="showPassword() ? 'text' : 'password'"
                    class="appearance-none block grow text-gray-700 border border-gray-200 rounded-l-lg py-4 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                    formControlName="password"
                    id="password"/>
                  <button (click)="showPassword.set(!showPassword())"
                          class="px-4 py-4 rounded-r-lg border border-l-0 border-gray-200 focus:outline-none"
                          type="button">
                    <svg class="flex-shrink-0 size-5 text-gray-500" fill="none" height="24"
                         stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                         viewBox="0 0 24 24"
                         width="24">
                      @if (!showPassword()) {
                        <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/>
                        <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/>
                        <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/>
                        <line x1="2" x2="22" y1="2" y2="22"/>
                      } @else {
                        <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/>
                        <circle cx="12" cy="12" r="3"/>
                      }
                    </svg>
                  </button>
                </div>
              </div>
              @if (form.controls.password.errors?.['required'] || form.controls.password.errors?.['pattern']) {
                <p class="peer-invalid:visible text-red-600 text-xs">
                  {{ 'passwordRules' | translate }}
                </p>
              }
            </div>
            <div class="mb-4">
              <p class="text-gray-500 text-base font-semibold pb-2 block">
                {{ 'yourProfile' | translate }}</p>
              <div class="flex items-center mt-3">
                <input [value]="Gender.Male"
                       class="w-4 h-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:bg-gray-500"
                       formControlName="gender"
                       id="gender-male"
                       name="gender"
                       type="radio">
                <label class="ms-2 text-base font-medium text-gray-500"
                       for="gender-male">{{ 'male' | translate }}</label>
              </div>
              <div class="flex items-center mt-2">
                <input [value]="Gender.Female"
                       class="w-4 h-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:bg-gray-500"
                       formControlName="gender"
                       id="gender-female"
                       name="gender"
                       type="radio">
                <label class="ms-2 text-base font-medium text-gray-500"
                       for="gender-female">{{ 'female' | translate }}</label>
              </div>
              <div class="flex items-center mt-2">
                <input [value]="Gender.Company"
                       class="w-4 h-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:bg-gray-500"
                       formControlName="gender"
                       id="gender-company"
                       name="gender"
                       type="radio">
                <label class="ms-2 text-base font-medium text-gray-500"
                       for="gender-company">{{ 'company' | translate }}</label>
              </div>
            </div>
            <div class="flex flex-col mb-4 text-gray-500">
              <p class="text-base font-semibold block">{{ 'notifications' | translate }}</p>
              <p class="text-sm font-medium">{{ 'notificationsMeans' | translate }}</p>
              <div class="flex gap-5 mt-3">
                <div class="flex flex-col gap-2">
                  <div class="grid grid-cols-3 gap-4 w-full">
                    <span class="text-base font-medium">{{ 'email' | translate }} <span
                      class="text-red-600">*</span></span>
                    <label class="ms-2 text-base font-medium text-gray-500">
                      <input [value]="true"
                             class="w-4 h-4 mr-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                             formControlName="emailConsent"
                             id="notification-email"
                             type="radio">
                      {{ 'yes' | translate }}
                    </label>
                    <label class="ms-2 text-base font-medium text-gray-500">
                      <input [value]="false"
                             class="w-4 h-4 mr-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                             formControlName="emailConsent"
                             id="notification-email"
                             type="radio">
                      {{ 'no' | translate }}
                    </label>
                    <span class="text-base font-medium">{{ 'sms' | translate }} <span
                      class="text-red-600">*</span></span>
                    <label class="ms-2 text-base font-medium text-gray-500">
                      <input [value]="true"
                             class="w-4 h-4 mr-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                             formControlName="smsConsent"
                             id="notification-sms"
                             type="radio">
                      {{ 'yes' | translate }}
                    </label>
                    <label class="ms-2 text-base font-medium text-gray-500">
                      <input [value]="false"
                             class="w-4 h-4 mr-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                             formControlName="smsConsent"
                             id="notification-sms"
                             type="radio">
                      {{ 'no' | translate }}
                    </label>
                    <span class="text-base font-medium">{{ 'courrier' | translate }} <span class="text-red-600">*</span></span>
                    <label class="ms-2 text-base font-medium text-gray-500">
                      <input [value]="true"
                             class="w-4 h-4 mr-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                             formControlName="courrierConsent"
                             id="notification-courrier"
                             type="radio">
                      {{ 'yes' | translate }}
                    </label>
                    <label class="ms-2 text-base font-medium text-gray-500">
                      <input [value]="false"
                             class="w-4 h-4 mr-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500"
                             formControlName="courrierConsent"
                             id="notification-courrier"
                             type="radio">
                      {{ 'no' | translate }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            @if (false) {
              <div class="flex items-center gap-3 mt-4 md:mt-2 mb-4 relative">
                <img [ngSrc]="photoUrl" alt="" class="w-16 h-16 rounded-full object-cover" height="60"
                     width="60"/>
                <button
                  (click)="changeAvatar()"
                  (keyup.enter)="emulateClick($event)"
                  class="bg-white hover:bg-beige text-gray-800 font-semibold py-3 px-6 border border-gray-300 rounded-lg disabled:bg-gray-500"
                  type="button">
                  {{ 'changeAvatar' | translate }}
                </button>
              </div>
            }

            <div class="flex items-center mt-4">
              <!-- Enabled: "bg-indigo-600", Not Enabled: "bg-gray-200" -->
              <button (click)="switchAcceptTerms()" [disabled]="form.disabled"
                      [ngClass]="acceptTerms() ? 'bg-bleuCaliceo-300' : 'bg-gray-200'"
                      aria-checked="false"
                      aria-labelledby="annual-billing-label"
                      class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none disabled:bg-gray-200"
                      role="switch" type="button">
                <span [ngClass]="acceptTerms() ? 'translate-x-5' : 'translate-x-0'"
                      aria-hidden="true"
                      class="translate-x-0 pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
              </button>
              <span class="ml-3 text-sm">
                <span class="font-medium text-gray-500">{{ 'acceptTermsSignUp' | translate }}</span>
              </span>
            </div>

            <p class="mt-10 text-rougeCaliceo-300">* {{ 'requiredInformation' | translate }}</p>
            <button [appProgressClick]="signUp"
                    [disabled]="form.invalid || !acceptTerms()"
                    appHoverGradient
                    class="big-btn flex justify-center items-center gap-2"
                    type="button">
              {{ 'validate' | translate }}
              <svg class="w-8 h-8" fill="none" stroke="#ffffff" viewBox="0 0 24 24">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <g clip-path="url(#clip0_429_11249)">
                    <path d="M20 7.00018L10 17.0002L5 12.0002" stroke="#ffffff" stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2.5"></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_429_11249">
                      <rect fill="white" height="24" width="24"></rect>
                    </clipPath>
                  </defs>
                </g>
              </svg>
            </button>
          </div>
        </form>
      </div>
    </section>
  </div>
}
